<template>
    <div v-if="client">
        <!-- password changing allowed -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Password changing</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.profile.passwordChangingAllowed"
                                type="checkbox"
                            />
                            allowed
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- lock player block shown -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Lock player block shown</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input
                                v-model="client.settings.viewSettings.profile.lockPlayerBlockShown"
                                type="checkbox"
                            />
                            shown
                        </label>
                    </p>
                </div>
            </div>
        </div>
        <!-- profile fields -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Profile fields</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <table class="table is-narrow is-size-7">
                            <tr>
                                <th>Field</th>
                                <th>Is enabled</th>
                                <th>Is required</th>
                            </tr>
                            <tr
                                v-for="field in client.settings.viewSettings.profile.profileFields"
                                :key="field.name"
                            >
                                <td>{{field.name}}</td>
                                <td>
                                    <label class="checkbox">
                                        <input v-model="field.isEnabled" type="checkbox" />
                                    </label>
                                </td>
                                <td>
                                    <label class="checkbox">
                                        <input v-model="field.isRequired" type="checkbox" />
                                    </label>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../../../../state';
import utils from '../../../../../utils';
import clientService from '../../../../../services/client.service';

import ContentStringRef from '../../../../common/content/string/content-string-ref.vue';

export default {
    name: 'client-settings-view-profile',
    components: { ContentStringRef },
    data() {
        return {
            client: null
        };
    },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        }
    },
    watch: {
        clientId() {
            this.loadClient();
        }
    },
    async mounted() {
        await clientService.ensure();
        this.loadClient();
    },
    methods: {
        loadClient() {
            this.client = utils.clone(state.clients.getClient(this.clientId));
        },
        async save() {
            await clientService.save(this.client);
            this.loadClient();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/view/profile.vue